import { c as _c } from "react/compiler-runtime";
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { cn } from '@/app/_lib/utils';
type CardVariant = 'light' | 'individual' | 'premium';
type CardProps = {
  title: string;
  details: string;
  children: React.ReactNode;
  variant?: CardVariant;
  goalPage?: boolean;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;
const headerVariants: Record<CardVariant, string> = {
  light: 'border-blue-200 from-blue-50 to-blue-100 bg-linear-to-r',
  individual: 'bg-linear-to-br border-blue-800 from-blue-700 to-blue-600',
  premium: 'border-algonavy-700 from-algonavy-950 via-algoprimary to-algosecondary bg-linear-to-br'
};
const titleVariants: Record<CardVariant, string> = {
  light: 'text-black',
  individual: 'text-white',
  premium: 'text-white'
};
const detailsVariants: Record<CardVariant, string> = {
  light: 'text-blue-600',
  individual: 'text-algonavy-100',
  premium: 'text-algoblue-100'
};
export const MentoringCard = t0 => {
  const $ = _c(34);
  let children;
  let className;
  let details;
  let props;
  let t1;
  let t2;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      details,
      children,
      variant: t1,
      goalPage: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = details;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = title;
  } else {
    children = $[1];
    className = $[2];
    details = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    title = $[7];
  }
  const variant = t1 === undefined ? "light" : t1;
  const goalPage = t2 === undefined ? false : t2;
  let t3;
  if ($[8] !== className) {
    t3 = cn("h-fit rounded-lg transition-colors", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = headerVariants[variant];
  let t5;
  if ($[10] !== t4) {
    t5 = cn("space-y-2 rounded-t-lg border p-6", t4);
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = titleVariants[variant];
  let t7;
  if ($[12] !== t6 || $[13] !== title) {
    t7 = <H3 className={t6}>{title}</H3>;
    $[12] = t6;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = detailsVariants[variant];
  let t9;
  if ($[15] !== t8) {
    t9 = cn("whitespace-pre-line", t8);
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== details || $[18] !== t9) {
    t10 = <P2 className={t9}>{details}</P2>;
    $[17] = details;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t7) {
    t11 = <header className={t5}>{t7}{t10}</header>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = goalPage && "dark";
  let t13;
  if ($[24] !== t12) {
    t13 = cn("rounded-b-lg border-borderPrimary border-x border-b bg-backgroundPrimary p-4 lg:p-6", t12);
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== children || $[27] !== t13) {
    t14 = <div className={t13}>{children}</div>;
    $[26] = children;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== props || $[30] !== t11 || $[31] !== t14 || $[32] !== t3) {
    t15 = <div className={t3} {...props}>{t11}{t14}</div>;
    $[29] = props;
    $[30] = t11;
    $[31] = t14;
    $[32] = t3;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};